/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CISConfigType {
    None = 0,
    DynaTouch = 1,
    InvoiceCloudV1 = 2,
    InvoiceCloudV2 = 3,
    ACT = 4,
    Csa = 5,
    Paymentus = 6,
    ConEd = 7,
    PayGo = 8,
    MyUsage = 9,
}
